export const filterAthletes = (entry, searchString) => {

    return searchString.toLowerCase().split(',').some(string => entry.athlete_name.toLowerCase().includes(string));

};
